<template>
    <div>
        <a @click="openHotlead(cardData)" v-if="cardData && cardData.isAgentcard">
            <mvtCardAgent :data="cardData"></mvtCardAgent>
        </a>
        <a v-else class="search-ads" :class="theme" @click="action" role="button">
            <div class="inline bg-white flex small vertical center middel text-center">
                <div class="h5 text-bold">{{title}}</div>
                <div class="f7 singleline"><span>{{subTitle}}</span></div>
                <div class="img"></div>
                <div class="btn primary small">{{linkText}}</div>
            </div>
        </a>
    </div>
</template>

<script src="./search-ads.js"></script>

<style lang="scss">
@use "./search-ads.scss" as *;
</style>
